<template>
	<div class="index">
			<!-- banner图 -->
			<div class="newsCenterBanenr">
				<img src="../../assets/xiangning/tjdj/tjdj_banner.png" >
			</div>
			<div class="home_wrap">
				    <!-- 通知公告上方标题栏 -->
					<div class="news_title">
						<div class="title_left">
                            <img src="../../assets/xiangning/home/titile_left.png" alt="">
					</div>
						<div class="news_title_left">
							<div class="news_title_left_text" :style="{color:'#000000',fontWeight:'800'}">图解党建</div>
							
						</div>
						<div class="right_back" @click="goHome">
							<div class="right_back_icon"><img src="../../assets/xiangning/dwgk/back.png" alt=""></div>
							<div >返回</div>
                        </div>
                   </div>
				   <!-- 图解党建内容部分 -->
				    <!-- 列表 -->
					<div  class="tjdjContentList">
						<!-- 列表循环点击打开弹出框 -->
						<div @click="goTjdjDetail(item.id)"  class="contentList_item" v-for="item in TjdjList" :key="item.id">
									<!-- 上方图片 -->
								<div class="top_img"><img :src="item.img" alt="">
								</div>
								<!-- 下方标题 -->
								<div class="bottom_title">
									<div class="bottom_title_main">
										{{ item.title }}
									</div>
								</div>
							</div>
				     </div>
					<!-- 下方分页器 -->
					<Page :total="total" :per_page="per_page" :pageSize="[12]" @handleCurrentChange="handleCurrentChange">
					</Page>

			</div>
			
	     </div>
</template>
<script>
	import { news } from '@/axios';
	// import Page from '@/components/Page.vue'
	import Page from '@/components/page.vue'
	export default{
		data(){
			return{
				// 总数据条数
				total:0,
				// 当前页码
				per_page:1,
				// 标题栏切换改变样式
				index:0,
				TjdjList:[]
			}
		},
		components:{Page},
		methods:{
			handleCurrentChange(page){
              this.per_page=page
			  this.getTjdjList()
			},
			goHome(){
				this.$router.push({
					path:'/home'
				})
			},
			// 获取图解党建列表
			getTjdjList(){
				let that=this
				news.getTjdjList({page:that.per_page}).then((res)=>{
					if (res.code==200) {
						that.TjdjList=res.data.pagedata
						that.total=res.data.count
					}
				})
			},
			// 跳转至图解党建详情
			goTjdjDetail(id){
              this.$router.push({
				path:'tidj_detail',
				query:{
					id:id
				}
			  })
			}
		  },
		mounted(){
		//获取图解党建详情
		 this.getTjdjList()
		},
		created() {
			this.$emit("highLight",this.$route.query.index,"","","");
		}
	}
</script>

<style lang="scss">
	@import '@/common/index.scss';
	.index{
		width: 100%;
		.newsCenterBanenr{
			position: relative;
			width: 100%;
			img{
				width: 100%;
				height: auto;
			}
		
		}
		div{
			box-sizing: border-box;
		}
		.home_wrap{
			.block{
				margin-bottom: 40px;
			}
			width: $indexWidth;
			margin: auto;
			min-width: 1200px;
		  
		/* 标题部分样式 */
		.news_title{
				
				height: 32px;
				width: 100%;
				margin:20px 0;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding-left:32px;
				background: #FFF6F1;
				box-sizing: border-box;
				position: relative;
				.title_left{
					position: absolute;
					top: -5px;
					left: 0;
					height: 42px;
					width: 42px;
					img{
						width: 100%;
						height: 100%;
					}
				}
			}
			.news_title_left{
				height: 22px;
				display: flex;
				justify-content: space-between;
				
			}
			.news_title_left_text{
				height: 22px;
				// width: 80px;
				padding: 0 20px;
				font-family: PingFangSC-Regular;
				font-size: 16px;
				font-weight: normal;
				letter-spacing: 0.1em;
				color: #999999;
			}
			.right_back{
				display: flex;
				font-family: PingFangSC-Regular;
				font-size: 12px;
				font-weight: normal;
				letter-spacing: 0em;
				color: #666666;
				margin-right: 10px;
			}
			.right_back:hover{
				font-weight: 800;
				color: #EE632B;
			}
			.right_back_icon{
				height: 10px;
				width: 12px;
				margin-right: 5px;
			}
			.right_back_icon img{
				height: 100%;
				width: 100%;
			}
			// 内容部分
             .tjdjContentList{
				margin-top: 20px;
				margin-bottom: 40px;
				// height: 992px;
				width: 100%;
				overflow: hidden;
				display: flex;
				justify-content: start;
				flex-wrap: wrap; 
				align-content: start;
				.contentList_item{
					height: 316px;
					width: 183px;
					margin-bottom: 20px;
					margin-right: 20px;
					.top_img{
						width: 100%;
						height: 256px;
						img{
							width: 100%;
							height: 100%;
						}
					}
					.bottom_title{
						height: 60px;
						width: 100%;
						border: 1px solid #ECEEF4;
						display: flex;
						justify-content: center;
						align-items: center;
						.bottom_title_main{
							height: 40px;
							width: 163px;
							font-family: PingFangSC-Medium;
							font-size: 14px;
							font-weight: 800;
							letter-spacing: 0em;
							color: #000000; 
							overflow:hidden; 
							text-overflow:ellipsis; 
							display:-webkit-box;  
							-webkit-box-orient:vertical;  
							-webkit-line-clamp:2;  

						}
					

					}
				
				}
				.contentList_item:nth-child(6n){
					margin-right: 0;
				}
			 }
		
			/* .分页器 */
			.pagination{
				height: 48px;
				width: 648px;
				margin: 0 auto;
				display: flex;
				justify-content: center;
				align-items: center;
				color: #C9010A;
			}
			.el-pagination .el-pager li:hover {
				color: #EE632B;
			}
			.el-pagination .el-pager li:not(.disabled):hover {
				color: #EE632B;
			}
			.el-pagination .el-pager li:not(.disabled).active {
			
				color: #EE632B;
			}
			.el-pagination .btn-prev:hover{
				
				color: #EE632B;
			}
			.el-pagination .btn-next:hover{
				color: #EE632B;
			}

			li.el-select-dropdown__item.selected{
				color: #EE632B!important;
			}

			.el-input__inner:hover{
				border-color:#EE632B !important;
			}
			.el-input__inner:focus{
				border-color:#EE632B !important;
			}
			
		}
	}
		
			
</style>
